// --- Custom Error Creation Utility ---
function createNamedError(name, message) {
    const error = new Error(message);
    error.name = name;
    return error;
}
/**
 * Creates an authentication module with methods ported from results-portal.
 * @param request - The configured request function from the API client.
 * @returns An object containing authentication methods.
 */
export function createAuthModule(request) {
    return {
        signIn: async (payload) => {
            try {
                return await request('POST', '/auth/login', false, payload);
            }
            catch (err) {
                const axiosError = err;
                if (axiosError.response?.status === 401) {
                    const error = new Error('Email or password is incorrect');
                    error.name = 'NotAuthorizedException';
                    throw error;
                }
                if (axiosError.response?.status === 429) {
                    const error = new Error('Too many attempts. Please try again later');
                    error.name = 'RateLimitedException';
                    throw error;
                }
                if (axiosError.response?.status === 400) {
                    const error = new Error('Email not verified');
                    error.name = 'UserNotConfirmedException';
                    throw error;
                }
                throw err;
            }
        },
        signOut: async () => {
            // Clearing localStorage or cookies should be handled by the application (results-portal).
        },
        signUp: async (payload) => {
            try {
                return await request('POST', '/auth/signup?type=link', false, payload);
            }
            catch (err) {
                const axiosError = err;
                if (axiosError.response?.status === 409) {
                    throw createNamedError('UsernameExistsException', 'This email already has an account');
                }
                if (axiosError.response?.status === 400) {
                    throw createNamedError('InvalidPasswordException', axiosError.response?.data?.message ?? 'Invalid Password');
                }
                throw err;
            }
        },
        confirmSignUp: async (payload) => {
            try {
                return await request('POST', '/auth/confirm_signup', false, payload);
            }
            catch (err) {
                const axiosError = err;
                if (axiosError.response?.status === 400) {
                    throw createNamedError('CodeMismatchException', 'Invalid verification code');
                }
                throw err;
            }
        },
        forgotPassword: async (payload) => {
            try {
                return await request('POST', '/auth/forgot_password', false, payload);
            }
            catch (err) {
                const axiosError = err;
                if (axiosError.response?.status === 400) {
                    throw createNamedError('UserNotFoundException', 'There is no account for this email');
                }
                throw err;
            }
        },
        forgotPasswordSubmit: async (payload) => {
            try {
                return await request('POST', '/auth/forgot_password_submit', false, payload);
            }
            catch (err) {
                const axiosError = err;
                if (axiosError.response?.status === 400 &&
                    axiosError.response?.data?.message === 'Verification code invalid') {
                    throw createNamedError('CodeMismatchException', 'Invalid verification code');
                }
                else if (axiosError.response?.status === 400) {
                    throw createNamedError('InvalidPasswordException', axiosError.response?.data?.message ?? 'Invalid Password');
                }
                throw err;
            }
        },
        completeNewPassword: async (payload) => {
            // No specific error handling in the provided snippet, so direct request.
            return request('POST', '/auth/complete_new_password', true, payload);
        },
        resendSignUp: async (payload) => {
            // No specific error handling in the provided snippet.
            return request('POST', '/auth/resend_signup?type=link', false, payload);
        },
    };
}
//# sourceMappingURL=auth.js.map